import { Lock } from "lucide-react";
import MetaField from "./ui/MetaField";
import { formatRestrictionDate } from "../utils/formatters";

export default function DistrictOverridePanel({ restriction }) {
  const { start, end, reason, createdBy, editedBy } = restriction;

  return (
    <div className="border border-[#DDDDDD] rounded p-3 flex flex-col gap-2 bg-amber-50">
      <div className="flex items-start gap-2">
        <Lock className="w-4 h-4 text-amber-500 shrink-0 mt-0.5" />
        <div className="flex flex-col gap-0.5">
          <span className="text-[16px] font-bold text-amber-800">
            App set to OFF at the district level
          </span>
          <span className="text-[16px] text-amber-700 opacity-75">
            Please ask district admin to turn the app on when your school is
            ready for students to use the app
          </span>
        </div>
      </div>

      <div className="h-px bg-amber-200" />
      <div className="grid grid-cols-2 gap-3">
        <MetaField label="Starts At" value={formatRestrictionDate(start)} />
        <MetaField label="Ends At" value={formatRestrictionDate(end)} />
      </div>

      <div className="h-px bg-amber-200" />

      <MetaField label="Reason" value={reason} />

      <p className="text-[14px] text-amber-600">
        Set by <span className="font-bold text-amber-800">{createdBy}</span>
      </p>
      {editedBy?.length > 0 && (
        <p className="text-[14px] text-amber-600">
          Edited by{" "}
          <span className="font-bold text-amber-800">
            {editedBy.join(", ")}
          </span>
        </p>
      )}
    </div>
  );
}
